/**
 * A filter chip's label with a tick when it is the one selected (proposal
 * 10): the selected court or list filter said so only with a tint. The
 * button keeps aria-pressed; the tick is for the eye, so it is hidden from
 * the accessible name.
 */
import type { ReactNode } from 'react';
import styles from './QualityTriagePages.module.css';

export default function FilterTick({ on, children }: { on: boolean; children: ReactNode }) {
  return (
    <span>
      {on && (
        <span className={styles.filterTick} aria-hidden="true" data-testid="filter-tick">
          ✓{' '}
        </span>
      )}
      {children}
    </span>
  );
}
